var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedCandidateCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.169,
    height: 17.169,
    viewBox: "0 0 17.169 17.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21563",
    "data-name": "Group 21563",
    transform: "translate(0.497 0.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21562",
    "data-name": "Group 21562",
    transform: "translate(-0.497 -0.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    d: "M130.338,180.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-125.452 -173.654)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    d: "M200.338,180.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-193.085 -173.654)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M270.338,180.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-260.717 -173.654)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M340.338,180.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-328.35 -173.654)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11094",
    "data-name": "Path 11094",
    d: "M410.338,180.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-395.982 -173.654)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M60.338,240.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-57.82 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11096",
    "data-name": "Path 11096",
    d: "M130.338,240.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-125.452 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11097",
    "data-name": "Path 11097",
    d: "M200.338,240.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-193.085 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M270.338,240.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-260.717 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M340.338,240.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-328.35 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M410.338,240.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-395.982 -231.625)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11101",
    "data-name": "Path 11101",
    d: "M60.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-57.82 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11102",
    "data-name": "Path 11102",
    d: "M130.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-125.452 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M200.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-193.085 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M270.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-260.717 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M340.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-328.35 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M410.338,300.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-395.982 -289.595)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M60.338,360.676h.338a.338.338,0,0,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-57.82 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11108",
    "data-name": "Path 11108",
    d: "M130.338,360.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-125.452 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11109",
    "data-name": "Path 11109",
    d: "M200.338,360.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-193.085 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11110",
    "data-name": "Path 11110",
    d: "M270.338,360.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-260.717 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11111",
    "data-name": "Path 11111",
    d: "M340.338,360.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-328.35 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M410.338,360.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,0,0,0,.676",
    transform: "translate(-395.982 -347.566)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M60.338,420.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-57.82 -405.537)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11114",
    "data-name": "Path 11114",
    d: "M130.338,420.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-125.452 -405.537)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11115",
    "data-name": "Path 11115",
    d: "M200.338,420.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-193.085 -405.537)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11116",
    "data-name": "Path 11116",
    d: "M270.338,420.676h.338a.338.338,0,1,0,0-.676h-.338a.338.338,0,1,0,0,.676",
    transform: "translate(-260.717 -405.537)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11117",
    "data-name": "Path 11117",
    d: "M16.573,1.353H14.882V1.184a1.184,1.184,0,1,0-2.368,0v.169H4.4V1.184a1.184,1.184,0,1,0-2.368,0v.169H.338A.338.338,0,0,0,0,1.691V16.573a.338.338,0,0,0,.338.338H16.573a.338.338,0,0,0,.338-.338V1.691a.338.338,0,0,0-.338-.338M13.19,1.184a.507.507,0,1,1,1.015,0V2.2a.507.507,0,1,1-1.015,0V1.184Zm-10.485,0a.507.507,0,0,1,1.015,0V2.2a.507.507,0,0,1-1.015,0V1.184ZM.676,2.029H2.029V2.2A1.184,1.184,0,0,0,4.4,2.2V2.029h8.117V2.2a1.184,1.184,0,1,0,2.368,0V2.029h1.353V4.059H.676ZM16.234,16.234H.676V4.735H16.234Z",
    transform: "translate(0.151 0.258)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedCandidateCalendar);
export default __webpack_public_path__ + "static/media/applied-candidate-calendar.1f25526c0b82df09f7a089242399b633.svg";
export { ForwardRef as ReactComponent };